<template>
  <div class="pa-3 ma-3">
    <SnackbarSMS
      ref="snackbarSms"
    >
    </SnackbarSMS>
    <v-row>
      <v-col cols="4">
        Rango de Fechas: 
        <date-picker v-model="busquedaItem.rango" range valueType="format" format="DD-MM-YYYY"></date-picker>
      </v-col>

      <v-col cols="4">
        <v-autocomplete
          v-model="busquedaItem.id_tecnico_radiologo"
          label="Técnico Radiólogo"
          :items="tecnicos_radiologos"
          item-text="nombre"
          item-value="id_usuario"
          clearable
          dense
          hide-details
          outlined
          :loading="loadingTecnicosRadiologos"
          :disabled="loadingTecnicosRadiologos"
        ></v-autocomplete>
      </v-col>

      <v-col cols="4">
        <v-autocomplete
          v-model="busquedaItem.id_radiologo"
          :items="radiologos"
          outlined
          label="Radiólogo"
          :item-text="nombreRadiologo"
          item-value="id_usuario"
          :loading="loadingRadiologos || loading"
          :disabled="loadingRadiologos || loading"
          dense
          hide-details
          clearable
        >
        </v-autocomplete>
      </v-col>


      <v-col cols="4">
        <v-autocomplete
          v-model="busquedaItem.id_unidad_medica"
          :items="unidades_medicas"
          outlined
          label="Unidad Medica"
          :item-text="codigoNombre"
          item-value="id_unidad_medica"
          :loading="loadingUnidadesMedicas || loading"
          :disabled="loadingUnidadesMedicas || loading"
          dense
          hide-details
          clearable
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="4">
        <v-autocomplete
          v-model="busquedaItem.id_proyecto"
          :items="proyectos"
          outlined
          label="Proyecto"
          :item-text="codigoNombre"
          item-value="id_proyecto"
          :loading="loadingProyectos ||loading"
          :disabled="loadingProyectos || loading"
          dense
          hide-details
          clearable
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model.lazy="busquedaItem.folio"
          label="Folio"
          outlined
          dense
          hide-details
          :loading="loading"
          :disabled="loading"
          clearable
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"
      >
        <v-btn
            block
            color="primary"
            text
            @click="downloadItems"
            :disabled="loading"
          >
            <v-icon>
              mdi-download
            </v-icon>
            Descargar Concentrado de Pacientes
          </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card elevation="0">
          <v-card-title class="justify-content-center">Distribución de Escalas BI-RADS </v-card-title>
          <v-card-text>
            <chart-donut
              ref="escalas"
            >
            </chart-donut>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :server-items-length="totalRecords"
          @update:page="getItems"
          @update:items-per-page="onItemsPerPageChange"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"  
        >
          <template v-slot:[`item.paciente`]="{ item }">
            {{item.nombre}} {{item.apellido_paterno}} {{item.apellido_materno}}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div style="display: flex; align-items: center; gap: 8px;">
              <v-img
                src="/img/download.png"
                width="32px"
                height="32px"
                contain
                style="cursor: pointer;"
                @click="nuevaPestana(`/api/Historial/ObtenerInterpretacion/${item.interpretacion_archivo}?jwt=${token}`)"
              />
              <v-img
                src="/img/sms.png"
                width="32px"
                height="32px"
                contain
                style="cursor: pointer;"
                @click="reenviarSMS(item.id_paciente_servicio, `${item.nombre} ${item.apellido_paterno} ${item.apellido_materno}`)"
              />
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import axios from 'axios'
import { mapState } from 'vuex'
import _ from 'lodash';
import ChartDonut from '@/components/Charts/Donut.vue'
import SnackbarSMS from './SnackbarSms.vue';

export default {
  components: {
    DatePicker,
    ChartDonut,
    SnackbarSMS
  },
    computed: {
    ...mapState(['token'])
  },
  data: () => ({
    loading: false,
    items: [],
    page: 1,
    itemsPerPage: 10,
    totalRecords: 0,
    headers: [
      {
          text: 'Fecha de Toma de Estudio',
          value: 'fecha_captura',
          align: 'center'
      },
      {
          text: 'Fecha de Interpretación',
          value: 'fecha_interpretacion',
          align: 'center'
      },
      {
          text: 'Folio',
          value: 'folio',
          align: 'center'
      },
      {
          text: 'Folio Servicio',
          value: 'folio_servicio',
          align: 'center'
      },
      {
          text: 'Paciente',
          value: 'paciente',
          align: 'center'
      },
      {
          text: 'Fecha de Nacimiento',
          value: 'fecha_nacimiento',
          align: 'center'
      },
      {
          text: 'Edad',
          value: 'edad',
          align: 'center'
      },
      {
          text: 'Género',
          value: 'genero',
          align: 'center'
      },
      { 
        text: "Técnico Radiólogo",
        value: "tecnico_radiologo",
        align: 'center',
        width: "11%"
      },
      {
          text: 'Radiólogo',
          value: 'radiologo',
          align: 'center'
      },
      {
          text: 'Estado',
          value: 'estado',
          align: 'center'
      },
      {
          text: 'Municipio',
          value: 'municipio',
          align: 'center'
      },
      {
          text: 'Localidad de Atención',
          value: 'localidad_atencion',
          align: 'center'
      },
      {
          text: 'Resultado',
          value: 'resultado',
          align: 'center'
      },
      {
          text: 'Interpretación',
          value: 'actions',
          align: 'center',
          width: '10%'
      },
    ],
    busquedaItem: {
      rango: null,
      id_unidad_medica: null,
      id_proyecto: null,
      id_tecnico_radiologo: null,
      id_radiologo: null,
      folio: null,
    },
    unidades_medicas: [],
    loadingUnidadesMedicas: false,
    radiologos: [],
    loadingRadiologos: false,
    proyectos: [],
    loadingProyectos: false,
    label_escala_cancer_mama: [],
    cantidad_escala_cancer_mama: [],
    colorMapBirads: {
      "0": "#BDBDBD",
      "1": "#4CAF50",
      "2": "#8BC34A",
      "3": "#FFEB3B",
      "4A": "#FFC107",
      "4B": "#FF9800",
      "4C": "#FF5722",
      "5": "#F44336",
      "6": "#9C27B0"
    },
    loadingTecnicosRadiologos: false,
    tecnicos_radiologos: []
  }),
  mounted() {
    this.getItems();
    this.getUnidadesMedicas();
    this.getRadiologos();
    this.getProyectos();
    this.getTecnicosRadiologos();
  },
  watch: {
    'busquedaItem.rango': function () {
      this.debouncedInput();
    },
    'busquedaItem.id_unidad_medica': function () {
      this.debouncedInput();
    },
    'busquedaItem.id_proyecto': function () {
      this.debouncedInput();
    },
    'busquedaItem.id_radiologo': function () {
      this.debouncedInput();
    },
    'busquedaItem.id_tecnico_radiologo': function () {
      this.debouncedInput();
    },
    'busquedaItem.folio': function () {
      this.debouncedInput();
    }
  },
  methods: {
    codigoNombre: item => `[${item.codigo}] - ${item.nombre}`,
    nombreRadiologo: item => `${item.nombre} ${item.apellido_paterno} ${item.apellido_materno}`,
    getUnidadesMedicas(){
      this.loadingUnidadesMedicas = true;
      axios
      .get('/Catalogos/ListarUnidadesMedicas?ignore_config=true')
      .then(response => {
        this.unidades_medicas = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingUnidadesMedicas = false;
      })
    },
    getRadiologos(){
      this.loadingRadiologos = true;
      axios
      .get('/ConsultasMastografias/ListarRadiologos')
      .then(response => {
        this.radiologos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingRadiologos = false;
      })
    },
    getUrl(base_url, token = false){
      const url = new URL(`http://localhost/${base_url}`);
      if(this.busquedaItem.rango != null && this.busquedaItem.rango.length == 2) {
        if(this.busquedaItem.rango[0] != null) url.searchParams.append("desde", this.busquedaItem.rango[0]);
        if(this.busquedaItem.rango[1] != null) url.searchParams.append("hasta", this.busquedaItem.rango[1]);
      }
      if(this.busquedaItem.id_unidad_medica != null) url.searchParams.append("id_unidad_medica", this.busquedaItem.id_unidad_medica);
      if(this.busquedaItem.id_radiologo != null) url.searchParams.append("id_radiologo", this.busquedaItem.id_radiologo);
      if(this.busquedaItem.id_tecnico_radiologo != null) url.searchParams.append("id_tecnico_radiologo", this.busquedaItem.id_tecnico_radiologo);
      if(this.busquedaItem.id_proyecto != null) url.searchParams.append("id_proyecto", this.busquedaItem.id_proyecto);
      if(this.busquedaItem.folio != null && this.busquedaItem.folio.length > 0) url.searchParams.append("folio", this.busquedaItem.folio);

      if(token) url.searchParams.append("jwt", this.token);
      else{
        url.searchParams.append("page", this.page);
        url.searchParams.append("size", this.itemsPerPage);
      }
      
      return url.href.replace('http://localhost', '');
    },
    onItemsPerPageChange(value){
      this.page = 1;
      this.itemsPerPage = value;
      this.getItems();
    },
    getItems() {
      this.items = [];
      
      var url_string = this.getUrl('InterpretacionesRadiologicas/ConcentradoResultados');

      this.loading = true;
      axios.get(url_string)
        .then(response => {
          this.items = response.data.desgloce.results;
          this.totalRecords = response.data.desgloce.total_records;

          this.label_escala_cancer_mama = response.data.label_escala_cancer_mama;
          this.cantidad_escala_cancer_mama = response.data.cantidad_escala_cancer_mama;
          this.$refs.escalas.setData(response.data.cantidad_escala_cancer_mama, response.data.label_escala_cancer_mama, this.colorMapBirads);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    downloadItems() {
      var url_string = this.getUrl('api/InterpretacionesRadiologicas/DescargarConcentradoResultados', true);
      this.nuevaPestana(url_string);
    },
    getProyectos(){
      this.loadingProyectos = true;
      axios
      .get('/Catalogos/ListarProyectos?solo_activos=false')
      .then(response => {
        this.proyectos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingProyectos = false;
      })
    },
    nuevaPestana(url) {
      window.open(url, '_blank');
    },
    reenviarSMS(id_paciente_servicio, nombre_paciente){
      axios
      .post(`/InterpretacionesRadiologicas/ReenviarSMS/${id_paciente_servicio}`)
      .then(() => {
        this.$refs.snackbarSms.mostrarMensaje(true, nombre_paciente);
      })
      .catch(error => {
        this.$refs.snackbarSms.mostrarMensaje(false, nombre_paciente);
        console.log(error);
      });
    },
    debouncedInput: _.debounce(function() {
      this.page = 1;
      this.getItems();
    }, 1000),
    getTecnicosRadiologos(){
      this.loadingTecnicosRadiologos= true;
      axios
      .get('/ConsultasMastografias/GetTecnicosRadiologos')
      .then(response => {
        this.tecnicos_radiologos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingTecnicosRadiologos = false;
      })
    }
  }
}
</script>
